<!-- Brand Logo -->
<a [routerLink]="['/dash']" class="brand-link">
    <img
        src="../../../../assets/img/cktech.png"
        alt="AdminLTE Logo"
        height="35"
    >
</a>

<!-- Sidebar -->
<div class="sidebar">
    <div class="form-inline">
        <app-sidebar-search></app-sidebar-search>
    </div>

    <!-- Sidebar Menu -->
    <nav class="mt-2">
        <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
        >
            <app-menu-item *ngFor="let item of menuItems" [menuItem]="item" />
        </ul>
    </nav>
</div>